import * as React from 'react';
import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';

export interface HTMLContentProps extends React.HTMLAttributes<HTMLDivElement> {
  content: string;
  asChild?: boolean;
}

const HTMLContent = React.forwardRef<HTMLDivElement, HTMLContentProps>(
  ({ content, className, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'div';

    if (!content) return null;

    return (
      <Comp
        ref={ref}
        className={cn(className)}
        dangerouslySetInnerHTML={{ __html: content }}
        {...props}
      />
    );
  }
);

HTMLContent.displayName = 'HTMLContent';

export { HTMLContent };
